module.exports = __webpack_public_path__ + "img/primary-logo-icon.66365608.svg";